// extracted by mini-css-extract-plugin
module.exports =  {"mandatory":"AssignLabelsModal-module_mandatory_be9f7"};